(function ($) {
  $('.slider').flickity({
    prevNextButtons: true,
    wrapAround: false,
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    imagesLoaded: true
  });
})(jQuery);